export const MEGA_MENU_GUTTER_SPACE = 20;
export const PAGE_TYPE = { LISTING: 'listing', CURATION: 'mm' };
export const HEADER_HEIGHT = 56;
export const EXPANDED_TITLE_HEIGHT = 60;
export const SHOP_TITLE = 'Categories';
